var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgGroup2Ic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 387,
    viewBox: "0 0 510 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 228.717,
    y: 89.5954,
    width: 105.33,
    height: 266.85,
    rx: 52.665,
    transform: "rotate(-49.9455 228.717 89.5954)",
    stroke: "url(#paint0_linear_1043_89162)",
    strokeWidth: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.263672,
    y: 120.327,
    width: 117.33,
    height: 412.95,
    rx: 58.665,
    transform: "rotate(-49.9455 0.263672 120.327)",
    fill: "url(#paint1_linear_1043_89162)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_89162",
    x1: 278.929,
    y1: 90.3269,
    x2: 278.929,
    y2: 369.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98B6F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_89162",
    x1: 58.9287,
    y1: 120.327,
    x2: 58.9287,
    y2: 533.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EEAD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGroup2Ic);
export default __webpack_public_path__ + "static/media/bgGroup2_ic.cb78e60f.svg";
export { ForwardRef as ReactComponent };